import type { KeyboardToolbarProps } from "react-native-keyboard-controller";
import {
  DefaultKeyboardToolbarTheme,
  KeyboardToolbar,
} from "react-native-keyboard-controller";

import { KeyboardToolbarOpacity } from "@/constants/UI";
import { ColorToken, ColorTokenValues } from "@/ui/theme/tokens";

const PrimaryColor = ColorTokenValues[ColorToken.Primary100];

const Theme: KeyboardToolbarProps["theme"] = {
  ...DefaultKeyboardToolbarTheme,

  dark: {
    ...DefaultKeyboardToolbarTheme.dark,
    primary: PrimaryColor,
  },
  light: {
    ...DefaultKeyboardToolbarTheme.light,
    primary: PrimaryColor,
  },
};

const KeyboardDoneToolbar = () => (
  <KeyboardToolbar opacity={KeyboardToolbarOpacity} theme={Theme}>
    <KeyboardToolbar.Done />
  </KeyboardToolbar>
);

export default KeyboardDoneToolbar;
